// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2iV6j","checkboxCol":"Table_checkboxCol__iZKST","emailCol":"Table_emailCol__3tgcJ","actionCol":"Table_actionCol__GDtc-"};